import uiRouter from 'angular-ui-router';
import myVacationsMobile from './myVacationsMobile.component';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';
import periodListLink from './periodListLink/periodListLink';

let myVacationsMobileModule = angular.module('vacations-absences.myVacationsMobile', [
  uiRouter,
  periodListLink
])

.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state(STATES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE, {
      url: ROUTES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE,
      component: 'myVacationsMobile',
      data:{
        requiresAuth:true
      }
    });
})

.component('myVacationsMobile', myVacationsMobile)

.name;

export default myVacationsMobileModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacationsMobile/myVacationsMobile.js